<template>
    <section id="form_section">
        <div class="container">
        <div class="head_row">
            <div class="text-column">
                <h1 class="title">Вибрати потрібний сервіс</h1>
            </div>
        </div>

        <div class="form_row_group_item mt-8">
            <div class="services-list">
                <div class="service-item" v-for="(service, i) in services" :key="`service_${i}`">
                    <a :href="service.url">
                        <div class="service-item_content">
                            <div class="service_img">
                                <img width="100" height="82" :src="service.image" />
                            </div>
                            <div class="service-item_info">
                                <p class="service_title">{{ service.title }}</p>
                                <p class="service_description">{{ service.description }}</p>
                            </div>
                        </div>
                    </a>
                </div>
            </div>
        </div>
        </div>
    </section>
</template>

<script>
import PreloadForm from "@/Components/PreloadForm";
import Fieldset from 'primevue/fieldset';
import Dropdown from 'primevue/dropdown';
import RadioButton from 'primevue/radiobutton';
import InputNumber from 'primevue/inputnumber';
import Checkbox from 'primevue/checkbox';
import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import ColumnGroup from "primevue/columngroup";
import Button from "primevue/button";
import Dialog from "primevue/dialog";
import Row from "primevue/row";
import axios from "axios";
import CommonLayout from "@/Layouts/CommonLayout";
import Label from '../Jetstream/Label.vue';
import Input from '../Jetstream/Input.vue';
import FormHelper from './mixins/form_helper';


export default {
    props: {
        services: {
            type: Object,
            required: false,
        }
    },

    components: {
        PreloadForm,
        Fieldset,
        Dropdown,
        RadioButton,
        InputNumber,
        Checkbox,
        TabView,
        TabPanel,
        DataTable,
        Column,
        Button,
        Dialog,
        ColumnGroup,
        Row,
        Input,
        Label
    },
    layout: CommonLayout,
    delimiters: ['${', '}'],
    mixins: [FormHelper],
    data() {
        return {
            //
        }
    }
};
</script>

<style scoped>
#form_section {
    max-width: 1296px;
    margin: 0 auto;
}
.mt-8 {
    margin-top: 80px;
}
.mt-24 {
    margin-top: 24px;
}
.mr-9 {
    margin-right: 90px;
}
.mb-5 {
    margin-bottom: 50px;
}
.mb-12 {
    margin-bottom: 12px;
}
.mb-16 {
    margin-bottom: 16px;
}
.gap-20 {
    gap: 20px;
}
.container {
    padding: 80px 60px 0 20px;
}
.additional_container {
    margin-top: 60px;
    display: flex;
    justify-content: space-between;
}
.additional_container .form_group {
    width: auto;
}
.select_grid {
    display: flex;
    justify-content: space-between;
    gap: 110px;
}
.btn-download {
    padding: 13px 30px;
    width: 220px;
    height: 51px;
    border: 1px solid #6C757D;
    border-radius: 4px;
    cursor: pointer;
    display: flex;
    align-items: center;
    color: #6C757D;
}
.btn-download:hover {
    background-color: #356EEF;
    color: #fff;
}
.btn-download:hover #download-icon {
    fill: #fff;
}
.btn-download svg{
    margin-right: 15px;
}
.form_row_group {
    display: flex;
    justify-content: space-between;
}
.head_row {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.title {
    /* font-family: 'Helvetica Neue'; */
    font-style: normal;
    font-weight: 700;
    font-size: 36px;
    line-height: 50px;
    color: #000000;
}

.services-list {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 24px;
}

.service-item {
    max-width: 416px;
    height: 187px;
    background: #FFFFFF;
    border-radius: 8px;
    border-left: 6px solid #C8E4FF;
    border-top: 1px solid #C8E4FF;
    border-right: 1px solid #C8E4FF;
    border-bottom: 1px solid #C8E4FF;
    cursor: pointer;
}

.service-item:hover {
    border-left: 6px solid #356EEF;
    box-shadow: 0px 5px 30px rgba(53, 110, 239, 0.18);
}

.service_title {
    /* font-family: 'Helvetica Neue'; */
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 27px;
    color: #000000;
    margin: 0;
    margin-bottom: 10px;
}

.service_description {
    /* font-family: 'Helvetica Neue'; */
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    color: #3A3A3A;
    margin: 0;
}

.service-item_content {
    display: flex;
    gap: 30px;
    padding: 30px 19px;
}

.service_img {
    display: flex;
    width: 100px;
}

@media (min-width: 1920px) {
    .services-list {
        gap: 24px;
    }
}

@media (max-width: 1190px) {
    .service_title {
        font-size: 15px;
        line-height: 20px;
    }
    .service_description {
        font-size: 10px;
        line-height: 21px;
    }
}

@media (max-width: 1100px) {
    .services-list {
        grid-template-columns: 1fr 1fr;
        gap: 24px;
    }
    .service_title {
        font-weight: 500;
        font-size: 16px;
        line-height: 24px;
    }
    .service_description {
        font-weight: 400;
        font-size: 12px;
        line-height: 20px;
    }
}

@media (max-width: 930px) {
    .mt-8 {
        margin-top: 40px!important;
    }

    .service-item_content {
        padding: 24px 10px;
        gap: 20px;
    }
    .service_img img {
        width: 90px;
        height: 88px;
    }
}

@media (max-width: 760px) {
    .services-list {
        grid-template-columns: 1fr;
        gap: 24px;
    }
    .service-item {
        max-width: 100%;
    }
    .container {
        padding: 50px 1rem 0 1rem;
    }
}

@media (max-width: 420px) {
    .service_img img {
        width: 60px;
        height: 62px;
    }
    .service_description {
        font-size: 14px;
        line-height: 21px;
    }
    .title {
        font-size: 30px;
        line-height: 42px;
    }
}

</style>
